<template>
    <div id="sources" class="card p-3">
      <page-title title="Voting polls"/>
        <div class="row">
            <div class="col-lg-12">
              <button class="btn btn-primary mb-3" @click="editWidget({})">
                New voting poll
              </button>
                <div class="widget-list component-list">
                    <div class="row form-group">
                        <div class="table-responsive col-sm-12">
                            <table class="table mt-3">
                                <thead class="thead">
                                <tr>
                                    <th scope="col" width="10%" class="text-left">#</th>
                                    <th scope="col" width="25%" class="text-left">Name</th>
                                    <th scope="col" width="20%" class="text-center">Votes</th>
                                    <th scope="col" width="15%" class="text-center">Created by</th>
                                    <th scope="col" width="15%" class="text-center">Updated by</th>
                                    <th scope="col" width="15%" class="text-center">

                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="!loading_status">
                                <tr v-for="item in widget_list" v-bind:data="item" v-bind:key="item.id">
                                    <th class="text-primary text-left">#{{ item.id }}</th>
                                    <td class="text-left">{{ item.name }}</td>
                                    <td class="text-center">{{ item.total_votes ? item.total_votes : 0 }}</td>
                                    <td class="text-center">{{ item.full_name }}</td>
                                    <td class="text-center">{{ item.last_update | formatDate }}</td>
                                    <td class="text-center">
                                        <a v-on:click.prevent="editWidget(item)"><i class="far fa-edit text-success mr-2 c-pointer" title="Edit"></i></a>
                                        <a v-on:click.prevent="confirmDelete(item)"><i class="fas fa-trash-alt text-danger mr-3 c-pointer" title="Delete"></i></a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <WidgetDialog :show="showModal" @close="showModal = false" :data="modalData" @onProcessed="onWidgetSaved"></WidgetDialog>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    import WidgetDialog from "./dialogs/WidgetDialog";
    import PageTitle from "../common/PageTitle";

    export default{
        name: 'voting-widgets',
        data(){
            return{
                widget: {},
                showModal: false,
                modalData: { name: '', items: []},
            }
        },
        components: {
            Datepicker,
            WidgetDialog,
            PageTitle
        },
        computed: {
            ...mapGetters([
                'votingWidgets',
                'user',
                'loading',
                'userID',
            ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            widget_list: {
                get:function() {
                    return this.votingWidgets;
                },
                set:function(newVal) {
                    return newVal;
                }
            },
        },
        methods: {
            ...mapActions([
                'getWidgets',
                'addWidget',
                'updateWidget',
                'deleteWidget',
                'setRightItem',
                'removeRightItems'
            ]),
            editWidget(item) {
                if(item.name) {
                    this.widget = item;
                    this.modalData = item;
                    this.modalData.method = this.getByID;
                } else {
                    this.widget = { name: '', items: [], }
                    this.modalData = this.widget;
                }

                this.showModal = true;
            },
            confirmDelete(item) {
                let vm = this;
                this.$dialog.confirm('Do you really want to delete this  #'+item.name+' voting poll?', {})
                    .then((dialog) => {
                        vm.deleteWidget({
                            id: item.id,
                        }).then((response) => {
                            dialog.close();
                        });
                    });
            },
            newItem() {
                this.widget = {};
            },
            getByID(id) {
                axios.get('/api/voting-widgets/'+id)
                    .then((response) => {
                        this.modalData = response.data.data;
                    }).catch((e) => {
                    console.log('unable to get poll', e);
                })
            },
            setRightSideItem(item) {
                this.setRightItem({
                    id: item.id,
                });
            },
            onWidgetSaved(data) {
                if(data) {
                    data.user_id = this.userID;

                    if (data.id) {
                        this.updateWidget(data);
                    } else {
                        this.addWidget(data);
                    }
                } else {
                    this.$store.commit('An error occurred while deleting voting poll');
                }
            },
        },
        mounted() {
            this.getWidgets();
        },
        watch: {
            votingWidgets: function(newVal) {
                this.widget_list = newVal;
            },

        },
    }
</script>

<style scoped="" lang="scss">
    button{
        padding-bottom: 7px;
    }
    .action-buttons input[type=checkbox]{
        position: relative;
        top: 1px;
        right: 3px;
    }
    .scontrols {
        button {
            margin-top: 5px;
            height: 33px;
        }
    }

    td {
        i {
            padding-right: 3px;
            cursor: pointer;
        }
    }
</style>
